import React from "react";

import { useGetCompanyDags } from "api/api-hooks/airflow-hooks";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { T } from "services/lang/LanguageService";
import { AirflowTaskId } from "types/airflow";

type AirflowTasksDropdownProps = {
  value: AirflowTaskId | undefined;
  onChange: (e: DropdownChangeEvent) => void;
};

const AirflowTasksDropdown: React.FC<AirflowTasksDropdownProps> = ({ value, onChange }) => {
  const { data, isLoading } = useGetCompanyDags();
  return (
    <Dropdown
      value={value}
      onChange={onChange}
      className="p-inputtext-sm"
      loading={isLoading}
      options={data?.map(dag => ({ dagId: dag.dagId, tasks: dag.tasks }))}
      optionLabel="id.taskId"
      optionGroupLabel="dagId"
      optionGroupChildren="tasks"
      optionValue="id"
      placeholder={T("word.select-one")}
      filter
      filterBy="id.taskId"
    />
  );
};

export default AirflowTasksDropdown;
